/** Fired after a task write so an open gate panel can reload readiness. */
type Listener = (projectId: string) => void;
const listeners = new Set<Listener>();

export function subscribeProjectTasksChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function notifyProjectTasksChanged(projectId: string): void {
  if (!projectId) return;
  listeners.forEach((listener) => listener(projectId));
}
